/* ApnaCircle static data: translations (Hindi + English), categories,
   U.S. states, regions, and India's international airports.
   Language codes: "en" (default) and "hi". */

export const I18N = {
  hi: {
    tagline:"आपका लोकल भारतीय समुदाय, एक ही जगह",
    search_ph:"सामान, कमरे, नौकरी, टिफ़िन खोजें…",
    nav_home:"होम",
    nav_inbox:"मैसेज",
    nav_post:"पोस्ट करें",
    nav_saved:"सेव किए",
    nav_me:"खाता",
    loc_all:"पूरा अमेरिका",
    loc_title:"अपना इलाका चुनें",
    loc_zip:"ZIP कोड",
    loc_zip_ph:"जैसे 75024",
    loc_state:"राज्य चुनें",
    loc_radius:"ZIP से दूरी",
    loc_gps:"मेरी लोकेशन इस्तेमाल करें",
    loc_apply:"लिस्टिंग दिखाएँ",
    loc_or:"या",
    loc_zip_bad:"यह ZIP नहीं मिला। 5 अंक दोबारा जाँचें।",
    gps_fail:"यहाँ लोकेशन उपलब्ध नहीं है। ZIP डालें।",
    gps_wait:"आपकी लोकेशन ढूँढ रहे हैं…",
    all_states:"सभी राज्य",
    any_dist:"कोई भी दूरी",
    mi:"मील",
    sort_new:"सबसे नए",
    sort_near:"सबसे पास",
    sort_low:"कीमत: कम से ज़्यादा",
    sort_high:"कीमत: ज़्यादा से कम",
    results:"{n} लिस्टिंग",
    near:"{p} के पास",
    within:"{p} से {r} मील के अंदर",
    empty_t:"यहाँ अभी कोई लिस्टिंग नहीं है",
    empty_b:"दूरी बढ़ाएँ, कैटेगरी बदलें, या सबसे पहले पोस्ट करें।",
    empty_q:"“{q}” से कुछ नहीं मिला",
    empty_qb:"दूसरे शब्द आज़माएँ, या पूरे अमेरिका में खोजें।",
    widen:"पूरे अमेरिका में खोजें",
    post_first:"लिस्टिंग पोस्ट करें",
    clear_search:"खोज साफ़ करें",
    free:"मुफ़्त",
    ask:"कीमत पूछें",
    per_month:"/महीना",
    per_hour:"/घंटा",
    obo:"मोलभाव हो सकता है",
    cond_new:"नया",
    cond_likenew:"लगभग नया",
    cond_good:"अच्छा",
    cond_fair:"ठीक-ठाक",
    just_now:"अभी",
    m_ago:"{n} मिनट पहले",
    h_ago:"{n} घंटे पहले",
    d_ago:"{n} दिन पहले",
    posted:"{t} पोस्ट किया",
    load_more:"और दिखाएँ",
    new_badge:"नया",
    msg_seller:"मैसेज",
    call:"कॉल",
    save:"सेव करें",
    saved_btn:"सेव किया",
    share:"शेयर",
    copied:"लिंक कॉपी हो गया",
    report:"इस लिस्टिंग की रिपोर्ट करें",
    report_t:"लिस्टिंग की रिपोर्ट",
    report_r:["धोखा या पहले पैसे माँग रहा है", "गैर-कानूनी सामान या नौकरी", "गलत जानकारी", "डुप्लिकेट या स्पैम"],
    report_send:"रिपोर्ट भेजें",
    reported:"रिपोर्ट भेज दी गई। समुदाय का ध्यान रखने के लिए धन्यवाद।",
    details:"विवरण",
    seller:"पोस्ट करने वाले",
    member:"समुदाय सदस्य",
    safety_t:"सुरक्षित रहें",
    safety_market:"सार्वजनिक जगह पर मिलें, पैसे देने से पहले सामान जाँचें, और जिनसे कभी मिले नहीं उन्हें पैसे न भेजें।",
    safety_jobs:"असली नौकरी में कभी फ़ीस नहीं ली जाती, और कोई नियोक्ता आपका पासपोर्ट अपने पास नहीं रख सकता। अगर आपसे ज़बरदस्ती काम करवाया जा रहा है, तो 1-888-373-7888 पर कॉल करें (हिंदी सहित कई भाषाओं में मदद)।",
    safety_housing:"डिपॉज़िट देने से पहले कमरा खुद जाकर या वीडियो पर देखें, और लीज़ लिखित में लें।",
    safety_business:"डिपॉज़िट देने से पहले हिसाब-किताब, लीज़ और बिज़नेस लाइसेंस माँगें।",
    safety_services:"निजी दस्तावेज़ देने से पहले सेवा देने वाले का लाइसेंस जाँचें, जैसे वकील या टैक्स प्रिपेयर। वीज़ा या ग्रीन कार्ड की गारंटी कोई नहीं दे सकता।",
    related:"मिलती-जुलती लिस्टिंग",
    not_found:"यह लिस्टिंग अब नहीं है। शायद बिक गई या हटा दी गई।",
    back_home:"होम पर लौटें",
    sold:"बिक गया",
    own_listing:"यह आपकी लिस्टिंग है",
    post_h:"नई लिस्टिंग",
    steps:["फ़ोटो", "कैटेगरी", "विवरण", "कीमत और जगह", "जाँचें"],
    step_of:"चरण {a} / {b}",
    photos_hint:"6 तक फ़ोटो जोड़ें। पहली फ़ोटो कवर बनेगी।",
    add_photo:"फ़ोटो जोड़ें",
    photos_skip:"फ़ोटो नहीं है? हम आपकी कैटेगरी का कवर लगा देंगे।",
    cover:"कवर",
    pick_topic:"कैटेगरी चुनें",
    pick_sub:"सब-कैटेगरी चुनें",
    f_title:"शीर्षक",
    f_title_ph:"जैसे प्रेशर कुकर 5 लीटर, बहुत कम इस्तेमाल",
    f_desc:"विवरण",
    f_desc_ph:"हालत, साइज़, शर्तें, या कब मिल सकते हैं",
    f_cond:"हालत",
    f_price:"कीमत (USD)",
    f_unit:"कीमत का प्रकार",
    unit_fixed:"एक कीमत",
    unit_month:"प्रति महीना",
    unit_hour:"प्रति घंटा",
    unit_free:"मुफ़्त",
    unit_ask:"पूछें",
    f_neg:"ऑफ़र स्वीकार हैं",
    f_zip:"जगह का ZIP",
    f_name:"दिखने वाला नाम",
    f_name_ph:"जैसे प्रिया, माँ का टिफ़िन",
    f_line:"WhatsApp (वैकल्पिक)",
    f_phone:"फ़ोन (वैकल्पिक)",
    contact_hint:"लोग आपको हमेशा यहाँ मैसेज कर सकते हैं। फ़ोन नंबर तभी दिखेगा जब आप उसे जोड़ेंगे।",
    next:"आगे",
    back:"पीछे",
    publish:"लिस्टिंग पब्लिश करें",
    publishing:"पब्लिश हो रहा है…",
    published:"लिस्टिंग पब्लिश हो गई",
    err_title:"शीर्षक कम से कम 5 अक्षर का हो",
    err_desc:"कम से कम 10 अक्षर का विवरण लिखें",
    err_price:"कीमत अंकों में लिखें",
    err_zip:"सही 5 अंकों का ZIP डालें",
    err_name:"दिखने वाला नाम लिखें",
    err_photo:"यह फ़ोटो नहीं चलेगी। JPG या PNG आज़माएँ।",
    err_save:"पब्लिश नहीं हो सका। फिर से कोशिश करें।",
    err_big:"सारी फ़ोटो मिलाकर बहुत बड़ी हैं। एक-दो हटाएँ।",
    photo_proc:"फ़ोटो तैयार हो रही हैं…",
    discard:"ड्राफ़्ट साफ़ करें",
    preview:"लिस्टिंग का प्रीव्यू",
    inbox_h:"मैसेज",
    tab_buying:"खरीद रहे हैं",
    tab_selling:"बेच रहे हैं",
    inbox_empty:"अभी कोई मैसेज नहीं",
    inbox_empty_b:"बातचीत शुरू करने के लिए किसी लिस्टिंग पर ‘मैसेज’ दबाएँ।",
    inbox_empty_s:"जब कोई आपकी लिस्टिंग के बारे में पूछेगा, बातचीत यहाँ दिखेगी।",
    chat_ph:"मैसेज लिखें…",
    send:"भेजें",
    pick_chat:"पढ़ने के लिए बाईं ओर से बातचीत चुनें",
    quick:["क्या यह अभी भी उपलब्ध है?", "क्या और फ़ोटो भेज सकते हैं?", "क्या कीमत में मोलभाव हो सकता है?", "कहाँ मिल सकते हैं?"],
    buyer:"खरीदार",
    view_listing:"लिस्टिंग देखें",
    saved_h:"सेव किए",
    saved_empty:"अभी कुछ सेव नहीं किया",
    saved_empty_b:"किसी लिस्टिंग पर दिल का निशान दबाकर उसे यहाँ रखें।",
    me_h:"मेरा खाता",
    my_listings:"मेरी लिस्टिंग",
    no_mine:"आपने अभी कुछ पोस्ट नहीं किया है",
    mark_sold:"बिका हुआ मार्क करें",
    relist:"फिर से लिस्ट करें",
    del:"हटाएँ",
    confirm_del:"यह लिस्टिंग हमेशा के लिए हटाएँ?",
    confirm_del_b:"इससे जुड़ी बातचीत आपके मैसेज में रहेगी।",
    cancel:"रद्द करें",
    deleted:"लिस्टिंग हटा दी गई",
    marked_sold:"बिका हुआ मार्क किया",
    relisted:"लिस्टिंग फिर से लाइव है",
    settings:"सेटिंग्स",
    language:"भाषा",
    theme:"थीम",
    th_auto:"सिस्टम",
    th_light:"लाइट",
    th_dark:"डार्क",
    area:"खोज का इलाका",
    change:"बदलें",
    display_name:"लिस्टिंग पर दिखने वाला नाम",
    name_saved:"नाम सेव हो गया",
    about:"पूरे अमेरिका में भारतीयों के लिए लोकल कम्युनिटी ऐप। सामान खरीदें-बेचें, कमरे, नौकरी, टिफ़िन और सेवाएँ ढूँढें, और अपने आसपास के लोगों से जुड़ें।",
    save_fail:"सेव नहीं हो सका। फिर से कोशिश करें।",
    send_fail:"भेजा नहीं जा सका। फिर से कोशिश करें।",
    read_only:"यह खाता सिर्फ़ देख सकता है",
    theme_toggle:"थीम बदलें",
    install_app:"ऐप इंस्टॉल करें",
    install_benefit:"ApnaCircle को ऐप की तरह तेज़ी से खोलें",
    install_ios_steps:"Safari में शेयर बटन दबाएँ, फिर ‘Add to Home Screen’ चुनें",
    open_menu:"मेन्यू",
    close:"बंद करें",
    prev:"पिछली फ़ोटो",
    nextimg:"अगली फ़ोटो",
    remove:"फ़ोटो हटाएँ",
    categories:"कैटेगरी",
    all:"सभी",
    you_p:"आप: "
  },
  en: {
    tagline:"Your local Indian community, all in one place",
    search_ph:"Search items, rooms, jobs, tiffin…",
    nav_home:"Home",
    nav_inbox:"Messages",
    nav_post:"Post",
    nav_saved:"Saved",
    nav_me:"Account",
    loc_all:"All of USA",
    loc_title:"Choose your area",
    loc_zip:"ZIP code",
    loc_zip_ph:"e.g. 75024",
    loc_state:"Pick a state",
    loc_radius:"Distance from ZIP",
    loc_gps:"Use my location",
    loc_apply:"Show listings",
    loc_or:"or",
    loc_zip_bad:"We couldn't find that ZIP. Check the 5 digits.",
    gps_fail:"Location isn't available here. Enter a ZIP instead.",
    gps_wait:"Finding you…",
    all_states:"All states",
    any_dist:"Any distance",
    mi:"mi",
    sort_new:"Newest",
    sort_near:"Nearest",
    sort_low:"Price: low to high",
    sort_high:"Price: high to low",
    results:"{n} listings",
    near:"Near {p}",
    within:"{p} within {r} mi",
    empty_t:"No listings here yet",
    empty_b:"Widen the distance, switch categories, or be the first to post.",
    empty_q:"Nothing matches “{q}”",
    empty_qb:"Try other words, or search all of USA.",
    widen:"Search all of USA",
    post_first:"Post a listing",
    clear_search:"Clear search",
    free:"Free",
    ask:"Ask for price",
    per_month:"/mo",
    per_hour:"/hr",
    obo:"Negotiable",
    cond_new:"New",
    cond_likenew:"Like new",
    cond_good:"Good",
    cond_fair:"Fair",
    just_now:"Just now",
    m_ago:"{n}m ago",
    h_ago:"{n}h ago",
    d_ago:"{n}d ago",
    posted:"Posted {t}",
    load_more:"Show more",
    new_badge:"New",
    msg_seller:"Message",
    call:"Call",
    save:"Save",
    saved_btn:"Saved",
    share:"Share",
    copied:"Link copied",
    report:"Report this listing",
    report_t:"Report listing",
    report_r:["Scam or asks for money upfront", "Illegal item or job", "Misleading details", "Duplicate or spam"],
    report_send:"Send report",
    reported:"Report sent. Thanks for looking out for the community.",
    details:"Details",
    seller:"Posted by",
    member:"Community member",
    safety_t:"Stay safe",
    safety_market:"Meet in a public place, check the item before you pay, and never send money to someone you haven't met.",
    safety_jobs:"Real jobs never charge a fee, and no employer may keep your passport. If you're forced to work, call 1-888-373-7888 (Hindi and many other languages available).",
    safety_housing:"See the room in person or on video before paying a deposit, and get the lease in writing.",
    safety_business:"Ask for financials, the lease and business licenses before putting down a deposit.",
    safety_services:"Check the provider's license, such as an attorney or tax preparer, before sharing personal documents. No one can guarantee a visa or green card.",
    related:"Similar listings",
    not_found:"This listing is gone. It may have sold or been removed.",
    back_home:"Back to home",
    sold:"Sold",
    own_listing:"This is your listing",
    post_h:"New listing",
    steps:["Photos", "Category", "Details", "Price & place", "Review"],
    step_of:"Step {a} of {b}",
    photos_hint:"Add up to 6 photos. The first one is the cover.",
    add_photo:"Add photos",
    photos_skip:"No photos? We'll use a cover for your category.",
    cover:"Cover",
    pick_topic:"Choose a category",
    pick_sub:"Choose a subcategory",
    f_title:"Title",
    f_title_ph:"e.g. Pressure cooker 5L, barely used",
    f_desc:"Description",
    f_desc_ph:"Condition, size, terms, or when you can meet",
    f_cond:"Condition",
    f_price:"Price (USD)",
    f_unit:"Price type",
    unit_fixed:"One price",
    unit_month:"Per month",
    unit_hour:"Per hour",
    unit_free:"Free",
    unit_ask:"Ask",
    f_neg:"Open to offers",
    f_zip:"Location ZIP",
    f_name:"Display name",
    f_name_ph:"e.g. Priya, Maa's Tiffin",
    f_line:"WhatsApp (optional)",
    f_phone:"Phone (optional)",
    contact_hint:"People can always message you here. Your phone is shown only if you add it.",
    next:"Next",
    back:"Back",
    publish:"Publish listing",
    publishing:"Publishing…",
    published:"Listing published",
    err_title:"Title needs at least 5 characters",
    err_desc:"Add at least 10 characters of detail",
    err_price:"Enter the price as a number",
    err_zip:"Enter a real 5-digit ZIP",
    err_name:"Enter a display name",
    err_photo:"That photo won't work. Try a JPG or PNG.",
    err_save:"Couldn't publish. Try again.",
    err_big:"Photos are too large together. Remove one or two.",
    photo_proc:"Preparing photos…",
    discard:"Clear draft",
    preview:"Listing preview",
    inbox_h:"Messages",
    tab_buying:"Buying",
    tab_selling:"Selling",
    inbox_empty:"No messages yet",
    inbox_empty_b:"Tap Message on any listing to start a chat.",
    inbox_empty_s:"When someone asks about your listings, the chat shows up here.",
    chat_ph:"Write a message…",
    send:"Send",
    pick_chat:"Pick a conversation on the left to read it",
    quick:["Is this still available?", "Can you send more photos?", "Is the price negotiable?", "Where can we meet?"],
    buyer:"Buyer",
    view_listing:"View listing",
    saved_h:"Saved",
    saved_empty:"Nothing saved yet",
    saved_empty_b:"Tap the heart on a listing to keep it here.",
    me_h:"My account",
    my_listings:"My listings",
    no_mine:"You haven't posted anything yet",
    mark_sold:"Mark sold",
    relist:"Relist",
    del:"Delete",
    confirm_del:"Delete this listing for good?",
    confirm_del_b:"Related chats stay in your inbox.",
    cancel:"Cancel",
    deleted:"Listing deleted",
    marked_sold:"Marked as sold",
    relisted:"Listing is live again",
    settings:"Settings",
    language:"Language",
    theme:"Theme",
    th_auto:"System",
    th_light:"Light",
    th_dark:"Dark",
    area:"Search area",
    change:"Change",
    display_name:"Name shown on listings",
    name_saved:"Name saved",
    about:"The local community app for Indians across the U.S. Buy and sell, find rooms, jobs, tiffin and services, and connect with people near you.",
    save_fail:"Couldn't save. Try again.",
    send_fail:"Couldn't send. Try again.",
    read_only:"This account can only view",
    theme_toggle:"Switch theme",
    install_app:"Install app",
    install_benefit:"Open faster and use ApnaCircle like an app",
    install_ios_steps:"Tap Safari's Share button, then choose ‘Add to Home Screen’",
    open_menu:"Menu",
    close:"Close",
    prev:"Previous photo",
    nextimg:"Next photo",
    remove:"Remove photo",
    categories:"Categories",
    all:"All",
    you_p:"You: "
  }
};

export const CATS = [
  {id:"all", hi:"सभी", en:"All", icon:"grid"},
  {id:"marketplace", hi:"बाज़ार", en:"Marketplace", icon:"tag", grad:["#0B1F3A", "#2D5A93"], safety:"market",
    subs:[["furniture","फ़र्नीचर","Furniture","sofa"],["electronics","इलेक्ट्रॉनिक्स","Electronics","tablet"],["appliances","घरेलू उपकरण","Appliances","pot"],["home_kitchen","घर और रसोई","Home & Kitchen","pot"],["clothing","कपड़े","Clothing","shirt"],["shoes","जूते","Shoes","shirt"],["jewelry_accessories","गहने और एक्सेसरीज़","Jewelry & Accessories","sparkle"],["baby_kids","बच्चों का सामान","Baby & Kids","stroller"],["toys","खिलौने","Toys","box"],["sports_fitness","खेल और फ़िटनेस","Sports & Fitness","box"],["books","किताबें","Books","book"],["tools","औज़ार","Tools","wrench"],["indian_kitchen_items","भारतीय रसोई का सामान","Indian Kitchen Items","pot"],["festival_puja_items","त्योहार और पूजा सामग्री","Festival & Puja Items","lotus"],["free_stuff","मुफ़्त सामान","Free Stuff","box"],["other","अन्य","Other","tag"]]},
  {id:"housing", hi:"कमरे और किराया", en:"Rooms & Rentals", icon:"house", grad:["#15424F", "#2E7C80"], safety:"housing",
    subs:[["private_room","प्राइवेट कमरा","Private Room","bed"],["shared_room","शेयर्ड कमरा","Shared Room","bed"],["apartment","अपार्टमेंट","Apartment","house"],["house","घर","House","house"],["sublease","सबलीज़","Sublease","key"],["roommate_wanted","रूममेट चाहिए","Roommate Wanted","people"],["temporary_stay","कुछ दिनों का ठहराव","Temporary Stay","bed"],["paying_guest","पेइंग गेस्ट","Paying Guest","key"],["student_housing","स्टूडेंट हाउसिंग","Student Housing","book"]]},
  {id:"jobs", hi:"नौकरियाँ", en:"Jobs", icon:"briefcase", grad:["#3E2A6B", "#6C4FB0"], safety:"jobs",
    subs:[["it_software","आईटी और सॉफ़्टवेयर","IT & Software","tablet"],["data_analytics","डेटा और एनालिटिक्स","Data & Analytics","calc"],["engineering","इंजीनियरिंग","Engineering","wrench"],["healthcare","हेल्थकेयर","Healthcare","shield"],["restaurant_hospitality","रेस्टोरेंट और हॉस्पिटैलिटी","Restaurant & Hospitality","chef"],["retail","रिटेल","Retail","cart"],["warehouse","वेयरहाउस","Warehouse","box"],["office_admin","ऑफ़िस और एडमिन","Office & Admin","briefcase"],["accounting_finance","अकाउंटिंग और फ़ाइनेंस","Accounting & Finance","calc"],["education","शिक्षा","Education","book"],["delivery_driver","डिलीवरी और ड्राइवर","Delivery & Driver","car"],["part_time","पार्ट-टाइम","Part-Time","clock"],["weekend_jobs","वीकेंड नौकरी","Weekend Jobs","calendar"],["internships","इंटर्नशिप","Internships","book"],["other","अन्य","Other","briefcase"]]},
  {id:"services", hi:"सेवाएँ", en:"Services", icon:"wrench", grad:["#5A3A12", "#B7791F"], safety:"services",
    subs:[["moving","सामान शिफ़्टिंग","Moving","box"],["cleaning","सफ़ाई","Cleaning","polish"],["handyman","मरम्मत का काम","Handyman","wrench"],["auto_services","गाड़ी की सर्विस","Auto Services","car"],["tax_accounting","टैक्स और अकाउंटिंग","Tax & Accounting","calc"],["immigration_support","इमिग्रेशन सहायता","Immigration Support","scale"],["photography_video","फ़ोटोग्राफ़ी और वीडियो","Photography & Video","camera"],["tutoring","ट्यूशन","Tutoring","book"],["translation","अनुवाद","Translation","lang"],["childcare","बच्चों की देखभाल","Childcare","stroller"],["elder_care","बुज़ुर्गों की देखभाल","Elder Care","people"],["beauty_salon","ब्यूटी और सैलून","Beauty & Salon","scissors"],["mehndi","मेहंदी","Mehndi","lotus"],["event_planning","इवेंट प्लानिंग","Event Planning","calendar"],["dj_entertainment","डीजे और मनोरंजन","DJ & Entertainment","sparkle"],["airport_ride","एयरपोर्ट राइड","Airport Ride","plane"],["delivery","डिलीवरी","Delivery","box"],["other","अन्य","Other","wrench"]]},
  {id:"food", hi:"खाना और टिफ़िन", en:"Food & Tiffin", icon:"bowl", grad:["#8A3B12", "#D9731F"], safety:"market",
    subs:[["tiffin_service","टिफ़िन सर्विस","Tiffin Service","bowl"],["home_cooked_meals","घर का बना खाना","Home-Cooked Meals","pot"],["vegetarian","शाकाहारी","Vegetarian","leaf"],["vegan","वीगन","Vegan","leaf"],["south_indian","दक्षिण भारतीय","South Indian","bowl"],["north_indian","उत्तर भारतीय","North Indian","bowl"],["gujarati","गुजराती","Gujarati","bowl"],["punjabi","पंजाबी","Punjabi","bowl"],["telugu","तेलुगु","Telugu","bowl"],["tamil","तमिल","Tamil","bowl"],["kerala","केरल","Kerala","bowl"],["bengali","बंगाली","Bengali","bowl"],["sweets_snacks","मिठाई और नमकीन","Sweets & Snacks","cup"],["catering","कैटरिंग","Catering","chef"],["meal_prep","मील प्रेप","Meal Prep","pot"]]},
  {id:"vehicles", hi:"गाड़ियाँ", en:"Vehicles", icon:"car", grad:["#1F3B57", "#3F6E99"], safety:"market",
    subs:[["cars","कार","Cars","car"],["suvs","एसयूवी","SUVs","car"],["trucks","ट्रक","Trucks","car"],["motorcycles","मोटरसाइकिल","Motorcycles","car"],["auto_parts","गाड़ी के पुर्ज़े","Auto Parts","wrench"],["tires_wheels","टायर और व्हील","Tires & Wheels","wrench"],["carpool","कारपूल","Carpool","people"],["ride_share","राइड शेयर","Ride Share","car"]]},
  {id:"events", hi:"इवेंट्स", en:"Events", icon:"calendar", grad:["#7A1F4F", "#C2417F"], safety:"market",
    subs:[["cultural_events","सांस्कृतिक कार्यक्रम","Cultural Events","lotus"],["religious_events","धार्मिक कार्यक्रम","Religious Events","temple"],["diwali","दिवाली","Diwali","sparkle"],["holi","होली","Holi","sparkle"],["navratri","नवरात्रि","Navratri","lotus"],["ganesh_festival","गणेश उत्सव","Ganesh Festival","temple"],["community_meetup","कम्युनिटी मीटअप","Community Meetup","people"],["networking","नेटवर्किंग","Networking","briefcase"],["cricket","क्रिकेट","Cricket","calendar"],["music_dance","संगीत और नृत्य","Music & Dance","sparkle"],["food_festival","फ़ूड फ़ेस्टिवल","Food Festival","bowl"],["fundraiser","फ़ंडरेज़र","Fundraiser","heart"],["kids_family","बच्चे और परिवार","Kids & Family","stroller"]]},
  {id:"businesses", hi:"लोकल बिज़नेस", en:"Local Businesses", icon:"store", grad:["#0E4D3A", "#1E7B34"], safety:"business",
    subs:[["indian_grocery","भारतीय किराना","Indian Grocery","cart"],["restaurant","रेस्टोरेंट","Restaurant","chef"],["sweet_shop","मिठाई की दुकान","Sweet Shop","cup"],["jewelry","ज्वेलरी","Jewelry","sparkle"],["clothing_boutique","कपड़े और बुटीक","Clothing & Boutique","shirt"],["travel","ट्रैवल","Travel","plane"],["real_estate","रियल एस्टेट","Real Estate","house"],["insurance","इंश्योरेंस","Insurance","shield"],["accounting","अकाउंटिंग","Accounting","calc"],["legal","कानूनी सेवाएँ","Legal","scale"],["healthcare","हेल्थकेयर","Healthcare","shield"],["salon","सैलून","Salon","scissors"],["temple_community_organization","मंदिर और सामुदायिक संस्था","Temple & Community Organization","temple"],["other","अन्य","Other","store"]]},
  {id:"community", hi:"समुदाय", en:"Community", icon:"people", grad:["#23405E", "#4F87B8"], safety:"market",
    subs:[["announcements","घोषणाएँ","Announcements","flag"],["new_to_the_city","शहर में नए","New to the City","pin"],["recommendations","सुझाव","Recommendations","heart"],["lost_found","खोया-पाया","Lost & Found","search"],["parents","माता-पिता","Parents","stroller"],["students","छात्र","Students","book"],["seniors","वरिष्ठ नागरिक","Seniors","people"],["cricket_groups","क्रिकेट ग्रुप","Cricket Groups","people"],["language_groups","भाषा ग्रुप","Language Groups","lang"],["volunteer","स्वयंसेवा","Volunteer","heart"],["community_help","सामुदायिक मदद","Community Help","people"],["general","सामान्य","General","chat"]]},
  {id:"eldercare", hi:"बुज़ुर्गों की देखभाल", en:"Elder care", icon:"heart", grad:["#6B2D5C", "#B0558F"], safety:"care",
    subs:[["need_help","मदद चाहिए","Need help","heart"],["offer_help","मदद कर सकते हैं","Offer help","heart"]]},
  {id:"carry", hi:"सामान भेजें", en:"Luggage space", icon:"plane", grad:["#0F3B5F", "#2A7AB0"], safety:"carry",
    subs:[["us_in","अमेरिका → भारत","US → India","plane"],["in_us","भारत → अमेरिका","India → US","plane"]]}
];

export const CAT = Object.fromEntries(CATS.map(c=>[c.id,c]));

export const STATES = [
["AL","अलबामा","Alabama"],
["AK","अलास्का","Alaska"],
["AZ","एरिज़ोना","Arizona"],
["AR","अर्कांसस","Arkansas"],
["CA","कैलिफ़ोर्निया","California"],
["CO","कोलोराडो","Colorado"],
["CT","कनेक्टिकट","Connecticut"],
["DE","डेलावेयर","Delaware"],
["DC","वॉशिंगटन डी.सी.","Washington, D.C."],
["FL","फ़्लोरिडा","Florida"],
["GA","जॉर्जिया","Georgia"],
["HI","हवाई","Hawaii"],
["ID","आइडाहो","Idaho"],
["IL","इलिनॉय","Illinois"],
["IN","इंडियाना","Indiana"],
["IA","आयोवा","Iowa"],
["KS","कैनसस","Kansas"],
["KY","केंटकी","Kentucky"],
["LA","लुइज़ियाना","Louisiana"],
["ME","मेन","Maine"],
["MD","मैरीलैंड","Maryland"],
["MA","मैसाचुसेट्स","Massachusetts"],
["MI","मिशिगन","Michigan"],
["MN","मिनेसोटा","Minnesota"],
["MS","मिसिसिपी","Mississippi"],
["MO","मिसौरी","Missouri"],
["MT","मोंटाना","Montana"],
["NE","नेब्रास्का","Nebraska"],
["NV","नेवादा","Nevada"],
["NH","न्यू हैम्पशायर","New Hampshire"],
["NJ","न्यू जर्सी","New Jersey"],
["NM","न्यू मेक्सिको","New Mexico"],
["NY","न्यूयॉर्क","New York"],
["NC","नॉर्थ कैरोलाइना","North Carolina"],
["ND","नॉर्थ डकोटा","North Dakota"],
["OH","ओहायो","Ohio"],
["OK","ओक्लाहोमा","Oklahoma"],
["OR","ओरेगन","Oregon"],
["PA","पेंसिल्वेनिया","Pennsylvania"],
["RI","रोड आइलैंड","Rhode Island"],
["SC","साउथ कैरोलाइना","South Carolina"],
["SD","साउथ डकोटा","South Dakota"],
["TN","टेनेसी","Tennessee"],
["TX","टेक्सास","Texas"],
["UT","यूटा","Utah"],
["VT","वरमॉन्ट","Vermont"],
["VA","वर्जीनिया","Virginia"],
["WA","वॉशिंगटन","Washington"],
["WV","वेस्ट वर्जीनिया","West Virginia"],
["WI","विस्कॉन्सिन","Wisconsin"],
["WY","वायोमिंग","Wyoming"]
];
export const STATE = Object.fromEntries(STATES.map(s=>[s[0],{hi:s[1],en:s[2]}]));

/* Line icons, 24px grid */
export const ICON = {
  download:"M12 3v12 M7 10l5 5 5-5 M4 20h16",
  grid:"M4 4h7v7H4z M13 4h7v7h-7z M4 13h7v7H4z M13 13h7v7h-7z",
  tag:"M3 12V4.5A1.5 1.5 0 0 1 4.5 3H12l9 9-9 9z M7.5 7.5h.01",
  house:"M3 11l9-7 9 7 M5 9.5V20h5v-6h4v6h5V9.5",
  briefcase:"M3 8h18v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z M8 8V5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v3 M3 13h18",
  store:"M4 10v10h16V10 M3 4h18l-1 5a3 3 0 0 1-5.5 1 3 3 0 0 1-5 0A3 3 0 0 1 4 9z M10 20v-5h4v5",
  bowl:"M3 11h18a9 9 0 0 1-18 0z M8 7.5c0-1.2 1-1.6 1-3 M12 7.5c0-1.2 1-1.6 1-3 M16 7.5c0-1.2 1-1.6 1-3",
  wrench:"M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.5 2.5-2.4-.6-.6-2.4z",
  chopsticks:"M3 12h18a9 9 0 0 1-18 0z M13 2l5 8 M18 2l3 8",
  temple:"M12 2l2.5 3h-5z M6 9l6-4 6 4 M3 13l9-5 9 5 M6 12v9 M18 12v9 M10 21v-5h4v5 M3 21h18",
  moon:"M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z M17 3l.7 1.8 1.8.7-1.8.7L17 8l-.7-1.8-1.8-.7 1.8-.7z",
  sofa:"M4 11V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3 M2 13a2 2 0 0 1 4 0v2h12v-2a2 2 0 0 1 4 0v4H2z M4 17v2 M20 17v2",
  pot:"M4 9h16v8a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3z M2 9h20 M9 6a3 3 0 0 1 6 0 M12 12v3",
  car:"M3 13l2-5a2 2 0 0 1 1.9-1.3h10.2A2 2 0 0 1 19 8l2 5v4H3z M3 13h18 M6 17v2 M18 17v2 M7 15h.01 M17 15h.01",
  tablet:"M6 3h12a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z M11 18h2",
  shirt:"M8 3L3 6l2 4 3-1v12h8V9l3 1 2-4-5-3a4 4 0 0 1-8 0z",
  stroller:"M4 4h2l3 9h9l2-6H8 M7.5 19a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0 M15.5 19a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0",
  box:"M3 7l9-4 9 4v10l-9 4-9-4z M3 7l9 4 9-4 M12 11v10",
  bed:"M3 18V6 M3 13h18v5 M11 13v-3h7a3 3 0 0 1 3 3 M5.5 10.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0",
  people:"M6 9a3 3 0 1 0 6 0a3 3 0 1 0-6 0 M2 20a7 7 0 0 1 14 0 M15 6.2a3 3 0 1 1 2.5 5.3 M18 14a6 6 0 0 1 4 6",
  key:"M4 8a4 4 0 1 0 8 0a4 4 0 1 0-8 0 M11 11l10 10 M17 17l2-2 M19.5 19.5l2-2",
  lotus:"M12 20c-4 0-8-3-9-8 3 0 6 1 9 4 3-3 6-4 9-4-1 5-5 8-9 8z M12 16c-2-2-3-5-2-9 1 .8 1.6 1.6 2 2.6.4-1 1-1.8 2-2.6 1 4 0 7-2 9z",
  chef:"M7 18h10v3H7z M7 18v-5a4 4 0 0 1-1-7.8A5 5 0 0 1 12 3a5 5 0 0 1 6 2.2A4 4 0 0 1 17 13v5",
  polish:"M9 10h6v10a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1z M10 10V6h4v4 M11 6V3h2v3",
  cart:"M3 4h2l2.5 11h11l2-8H6.5 M9 19.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0 M16 19.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0",
  cup:"M4 8h13v5a6 6 0 0 1-6 6h-1a6 6 0 0 1-6-6z M17 10h1.5a2.5 2.5 0 0 1 0 5H17 M8 3v2 M12 3v2",
  leaf:"M5 19C5 10 10 5 20 4c0 9-5 15-13 15z M5 19l8-8",
  calc:"M6 3h12a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z M8 7h8v3H8z M8.5 14h.01 M12 14h.01 M15.5 14h.01 M8.5 17h.01 M12 17h.01 M15.5 17h.01",
  scale:"M12 3v18 M7 21h10 M5 7h14 M5 7l-3 6a3 3 0 0 0 6 0z M19 7l-3 6a3 3 0 0 0 6 0z",
  plane:"M2 13l20-8-8 16-2.5-6.5z M11.5 14.5L22 5",
  lang:"M4 5h9 M8.5 3v2 M6 5c1 4 3 6 6 7 M11 5c-1 4-4 7-7 8 M13 21l4-9 4 9 M14.5 18h5",
  scissors:"M4 6.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0-5 0 M4 17.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0-5 0 M8.5 8L20 18 M8.5 16L20 6",
  book:"M4 19V5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2 2 2 0 0 0 2 2h13",
  calendar:"M4 5h16v15H4z M4 9h16 M8 3v4 M16 3v4 M8 13h3v3H8z",
  cards:"M4 6.5L11 4.5l3.5 13-7 2z M13.5 4.2l6 1.6-3.2 12.4 M8 10.5h.01",
  amulet:"M12 2.5a2 2 0 0 1 2 2 M9 6.5h6l1.2 3.2a6 6 0 1 1-8.4 0z M12 12v4 M10 14h4",
  /* ui */
  search:"M10.5 18a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15z M21 21l-5.2-5.2",
  pin:"M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z M12 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
  chat:"M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z",
  plus:"M12 5v14 M5 12h14",
  heart:"M12 20s-7.5-4.6-9.3-9.2A5 5 0 0 1 12 6a5 5 0 0 1 9.3 4.8C19.5 15.4 12 20 12 20z",
  user:"M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M4 21a8 8 0 0 1 16 0",
  home:"M3 11l9-7 9 7 M5 9.5V20h5v-6h4v6h5V9.5",
  sun:"M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10z M12 1.5v2 M12 20.5v2 M4.6 4.6l1.4 1.4 M18 18l1.4 1.4 M1.5 12h2 M20.5 12h2 M4.6 19.4L6 18 M18 6l1.4-1.4",
  moonui:"M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z",
  back:"M15 18l-6-6 6-6", right:"M9 18l6-6-6-6", down:"M6 9l6 6 6-6",
  share:"M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7 M12 3v13 M7 8l5-5 5 5",
  phone:"M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z",
  close:"M6 6l12 12 M18 6L6 18",
  camera:"M4 7h3l2-3h6l2 3h3a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z M12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
  check:"M5 12l5 5L20 7",
  trash:"M4 7h16 M9 7V4h6v3 M6 7l1 13h10l1-13",
  flag:"M5 21V4 M5 4h11l-2 4 2 4H5",
  send:"M21 3L10 14 M21 3l-7 18-4-7-7-4z",
  shield:"M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z M9 12l2 2 4-4",
  gps:"M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14z M12 2v3 M12 19v3 M2 12h3 M19 12h3 M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
  clock:"M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M12 7v5l3 2",
  sparkle:"M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z",
  sort:"M7 4v16 M3 16l4 4 4-4 M17 20V4 M13 8l4-4 4 4"
};

/* Hour in ms (used for "new" badges) */
export const H = 3600e3;

/* Thai provinces (for luggage-space routes) */

/* U.S. Census regions, used as zones on the luggage-space tab */
export const REGIONS = [
  ["west","पश्चिमी अमेरिका","West","AK AZ CA CO HI ID MT NV NM OR UT WA WY".split(" ")],
  ["midwest","मिडवेस्ट","Midwest","IL IN IA KS MI MN MO NE ND OH SD WI".split(" ")],
  ["south","दक्षिणी अमेरिका","South","AL AR DE DC FL GA KY LA MD MS NC OK SC TN TX VA WV".split(" ")],
  ["northeast","उत्तर-पूर्वी अमेरिका","Northeast","CT ME MA NH NJ NY PA RI VT".split(" ")],
];

/* India's international airports for luggage-space routes.
   [code, airport name HI, airport name EN, city HI, city EN, state (HI)] */
/* India's international airports for luggage-space routes: the 7 largest first,
   then A–Z by city. Keep in sync with IN_AIRPORTS in backend marketplace/views.py.
   [code, airport name HI, airport name EN, city HI, city EN, state (HI)] */
export const AIRPORTS = [
  ["DEL", "इंदिरा गांधी अंतरराष्ट्रीय", "Indira Gandhi Intl", "दिल्ली", "Delhi", "दिल्ली"],
  ["BOM", "छत्रपति शिवाजी महाराज अंतरराष्ट्रीय", "Chhatrapati Shivaji Maharaj Intl", "मुंबई", "Mumbai", "महाराष्ट्र"],
  ["BLR", "केम्पेगौड़ा अंतरराष्ट्रीय", "Kempegowda Intl", "बेंगलुरु", "Bengaluru", "कर्नाटक"],
  ["HYD", "राजीव गांधी अंतरराष्ट्रीय", "Rajiv Gandhi Intl", "हैदराबाद", "Hyderabad", "तेलंगाना"],
  ["MAA", "चेन्नई अंतरराष्ट्रीय", "Chennai Intl", "चेन्नई", "Chennai", "तमिलनाडु"],
  ["CCU", "नेताजी सुभाष चंद्र बोस अंतरराष्ट्रीय", "Netaji Subhas Chandra Bose Intl", "कोलकाता", "Kolkata", "पश्चिम बंगाल"],
  ["AMD", "सरदार वल्लभभाई पटेल अंतरराष्ट्रीय", "Sardar Vallabhbhai Patel Intl", "अहमदाबाद", "Ahmedabad", "गुजरात"],
  ["ATQ", "श्री गुरु राम दास जी अंतरराष्ट्रीय", "Sri Guru Ram Dass Jee Intl", "अमृतसर", "Amritsar", "पंजाब"],
  ["IXB", "बागडोगरा अंतरराष्ट्रीय", "Bagdogra Intl", "बागडोगरा (सिलीगुड़ी)", "Bagdogra (Siliguri)", "पश्चिम बंगाल"],
  ["BBI", "बीजू पटनायक अंतरराष्ट्रीय", "Biju Patnaik Intl", "भुवनेश्वर", "Bhubaneswar", "ओडिशा"],
  ["CCJ", "कालीकट अंतरराष्ट्रीय", "Calicut Intl", "कोझिकोड", "Kozhikode", "केरल"],
  ["CJB", "कोयंबटूर अंतरराष्ट्रीय", "Coimbatore Intl", "कोयंबटूर", "Coimbatore", "तमिलनाडु"],
  ["GAY", "गया अंतरराष्ट्रीय", "Gaya Intl", "गया", "Gaya", "बिहार"],
  ["GOI", "डाबोलिम", "Dabolim", "गोवा", "Goa", "गोवा"],
  ["GOX", "मनोहर अंतरराष्ट्रीय, मोपा", "Manohar Intl, Mopa", "गोवा (उत्तर)", "Goa (North)", "गोवा"],
  ["GAU", "लोकप्रिय गोपीनाथ बोरदोलोई अंतरराष्ट्रीय", "Lokpriya Gopinath Bordoloi Intl", "गुवाहाटी", "Guwahati", "असम"],
  ["IMF", "बीर टिकेंद्रजीत अंतरराष्ट्रीय", "Bir Tikendrajit Intl", "इंफाल", "Imphal", "मणिपुर"],
  ["IDR", "देवी अहिल्याबाई होलकर", "Devi Ahilyabai Holkar", "इंदौर", "Indore", "मध्य प्रदेश"],
  ["JAI", "जयपुर अंतरराष्ट्रीय", "Jaipur Intl", "जयपुर", "Jaipur", "राजस्थान"],
  ["CNN", "कन्नूर अंतरराष्ट्रीय", "Kannur Intl", "कन्नूर", "Kannur", "केरल"],
  ["COK", "कोच्चि अंतरराष्ट्रीय", "Cochin Intl", "कोच्चि", "Kochi", "केरल"],
  ["KBK", "कुशीनगर अंतरराष्ट्रीय", "Kushinagar Intl", "कुशीनगर", "Kushinagar", "उत्तर प्रदेश"],
  ["LKO", "चौधरी चरण सिंह अंतरराष्ट्रीय", "Chaudhary Charan Singh Intl", "लखनऊ", "Lucknow", "उत्तर प्रदेश"],
  ["IXM", "मदुरै अंतरराष्ट्रीय", "Madurai Intl", "मदुरै", "Madurai", "तमिलनाडु"],
  ["IXE", "मंगलुरु अंतरराष्ट्रीय", "Mangaluru Intl", "मंगलुरु", "Mangaluru", "कर्नाटक"],
  ["NAG", "डॉ. बाबासाहेब आंबेडकर अंतरराष्ट्रीय", "Dr. Babasaheb Ambedkar Intl", "नागपुर", "Nagpur", "महाराष्ट्र"],
  ["IXZ", "वीर सावरकर अंतरराष्ट्रीय", "Veer Savarkar Intl", "पोर्ट ब्लेयर", "Port Blair", "अंडमान और निकोबार"],
  ["PNQ", "पुणे", "Pune", "पुणे", "Pune", "महाराष्ट्र"],
  ["SXR", "शेख उल-आलम अंतरराष्ट्रीय", "Sheikh ul-Alam Intl", "श्रीनगर", "Srinagar", "जम्मू और कश्मीर"],
  ["STV", "सूरत अंतरराष्ट्रीय", "Surat Intl", "सूरत", "Surat", "गुजरात"],
  ["TRV", "तिरुवनंतपुरम अंतरराष्ट्रीय", "Thiruvananthapuram Intl", "तिरुवनंतपुरम", "Thiruvananthapuram", "केरल"],
  ["TRZ", "तिरुचिरापल्ली अंतरराष्ट्रीय", "Tiruchirappalli Intl", "तिरुचिरापल्ली", "Tiruchirappalli", "तमिलनाडु"],
  ["VNS", "लाल बहादुर शास्त्री अंतरराष्ट्रीय", "Lal Bahadur Shastri Intl", "वाराणसी", "Varanasi", "उत्तर प्रदेश"],
  ["VGA", "विजयवाड़ा अंतरराष्ट्रीय", "Vijayawada Intl", "विजयवाड़ा", "Vijayawada", "आंध्र प्रदेश"],
  ["VTZ", "विशाखापत्तनम अंतरराष्ट्रीय", "Visakhapatnam Intl", "विशाखापत्तनम", "Visakhapatnam", "आंध्र प्रदेश"],
];
